import styled, { css } from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

interface Props {
  new?: boolean;
}

export const CardSession = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
`;

export const ImageWrapper = styled.div`
  width: 64px;
  height: 64px;
  background: ${COLORS.GRAY_PLACEHOLDER};

  img {
    height: 100%;
  }
`;

export const InitSession = styled.a`
  color: ${COLORS.BLACK};
  font-size: 15px;
  display: inline-block;
  text-decoration: underline;
  margin-top: 4px;
`;

export const Session = styled.div`
  font-family: ${FONTS.ROBOTO};
  font-size: 14px;
  color: ${COLORS.GRAY_TEXT};
  margin-left: 16px;
`;

export const Nav = styled.nav``;

export const ItemWrapper = styled.li`
  border-bottom: 1px solid ${COLORS.GRAY};
`;

export const List = styled.ul`
  border-top: 1px solid ${COLORS.GRAY};
`;

export const Item = styled.a`
  font-family: ${FONTS.ROBOTO};
  font-size: 16px;
  color: ${COLORS.BLACK};
  text-transform: uppercase;
  padding: 17px 0;
  display: block;
  text-align: left;
`;

export const Text = styled.span`
  ${(props: Props) => props.new && css`
    &:after {
      content: '¡Nuevo!';
      color: #2c78ff;
      font-size: 12px;
      font-family: ${FONTS.ROBOTO_BOLD};
      text-transform: capitalize;
      margin-left: 30px;
    }
  `}
`;

export const Content = styled.div`
  padding: 0 28px;
`;

export const LogoComercio = styled.img``;

export const Allies = styled.div`
  display: flex;
  justify-content: space-around;
  max-width: 200px;
  height: 70px;
  margin: 25px auto;
  flex-wrap: wrap;

  img {
    height: 22px;
  }

  & > ${LogoComercio} {
    height: 16px;
  }

  @media (min-width: ${SIZE.MOBILE_LANDSCAPE}) {
    max-width: 100%;
    height: auto;

    img {
      margin: 6px 6px 0 0;
    }
  }
`;


export const ButtonAccount = styled(Button)`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 14px;
  border: 1px solid ${COLORS.BLACK_BOLD};
  border-radius: 6px;
  min-height: 30px;
  margin-right: 20px;
`;

export const User = styled.span`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 19px;
  color: ${COLORS.BLACK};
  display: block;
  width: 186px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const UserWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

export const CloseSession = styled.a`
  color: ${COLORS.GRAY_TEXT};
  font-size: 14px;
  text-decoration: underline;
  width: 76px;
  height: 36px;
  display: flex;
  align-items: center;
`;

export const LoaderWrapper = styled.span`
  right: 0;
  z-index: 10;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`

const MAIN = 'MainList';
CardSession.displayName = `${MAIN}/CardSession`;
ImageWrapper.displayName = `${MAIN}/ImageWrapper`;
InitSession.displayName = `${MAIN}/InitSession`;
Nav.displayName = `${MAIN}/Nav`;
ItemWrapper.displayName = `${MAIN}/ItemWrapper`;
Item.displayName = `${MAIN}/Item`;
Allies.displayName = `${MAIN}/Allies`;
ButtonAccount.displayName = `${MAIN}/ButtonAccount`;
User.displayName = `${MAIN}/User`;
UserWrapper.displayName = `${MAIN}/UserWrapper`;